import { useState } from 'react';

export default function SafeImage({ fallback = '/images/ha-lgq2.png', alt = '', ...props }) {
  const [failed, setFailed] = useState(false);

  return (
    <img
      {...props}
      alt={alt}
      src={failed ? fallback : props.src}
      onError={() => setFailed(true)}
    />
  );
}
